// IE 2026 10 24 / ODOO-347321 (находка Андрея, шина #102106 / #102127: Demo7, DataHub, 01W_00a, список Connectors — чипс connector=1001p_001 стоит, галочки в строке нет):
// канал селектора (имя строки чипса стола) → колонка строки выдачи, из которой читается значение для флажка строки (selectorFlags_refresh).
// Список публикует канал полем с selector_binding (F_id: selector_binding = connector): в строке значение лежит в колонке id, а не connector.
// Тот же порядок, что у бэка (widgets.py: канал fieldSelector.leftValue.value → поле с selector_binding == канал → его binding) и у фронта
// (onApplySelector__Click читает значение строки по fieldSelector.binding, строку стола ищет по fieldSelector.leftValue.value).
// Нет записи в fieldSelectors — прежнее соответствие IE 2026 10 23 / ODOO-347321 (source — канал, binding — колонка), без бинда — само имя канала.
// Чистая логика без Vue — юнит tests/unit/selectorCols.test.mjs

const _str = (v) => (v === null || v === undefined) ? '' : String(v).trim()

// канал → binding поля из doc.params.fieldSelectors: leftValue.value (как ищет строку стола get_rowWHERE) главнее selector_binding
export function selectorCols_fromFieldSelectors(fieldSelectors) {
    const out = {}
    if (!Array.isArray(fieldSelectors)) return out
    const list = fieldSelectors.filter(f => f && typeof f === 'object' && f.use !== false && _str(f.binding))
    for (const pick of [f => _str(f.leftValue?.value), f => _str(f.selector_binding)]) {
        for (const f of list) {
            const ch = pick(f)
            if (ch && !(ch in out)) out[ch] = _str(f.binding)
        }
    }
    return out
}

// rows — строки Selection → Fields виджета (selFields_rows); Set-без-Get поля: канал (source || binding) → колонка
export function selectorCols_map(rows, fieldSelectors) {
    const fromFs = selectorCols_fromFieldSelectors(fieldSelectors)
    const out = {}
    for (const r of Array.isArray(rows) ? rows : []) {
        if (!r || r.use === false || !r.selector_set || r.selector_get) continue
        const n = _str(r.source || r.binding)
        if (n && n !== 'date' && !(n in out)) out[n] = fromFs[n] || _str(r.binding || r.source) || n
    }
    return out
}
